import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "orderBy",
  standalone: true,
})
export class OrderByPipe implements PipeTransform {
  transform(array: any[], field: string): any[] {
    if (!Array.isArray(array) || !field) {
      return array;
    }


    if (array.some((item) => !item.hasOwnProperty(field))) {
      console.error(`Campo '${field}' no encontrado en algunos objetos`);
      return array;
    }

    return array
      .sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];

       
        if (typeof valueA === "string" && typeof valueB === "string") {
          return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
        }
      
        if (typeof valueA === "number" && typeof valueB === "number") {
          return valueA - valueB;
        }
       
        return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
      })
  }
}
